import axios, { API_URL } from './BaseService';

const URL = `${API_URL}/deposits`;

export async function getDeposits() {
    const response = await axios.get(URL);
    return response.data;
}

export async function quoteDeposit(amount) {
    const response = await axios.get(`${URL}/quote`, { params: { amount } });
    return response.data;
}

export async function createDeposit(amount) {
    const response = await axios.post(`${URL}/checkout`, { amount });
    return response.data;
}

export async function confirmDeposit(sessionId) {
    const response = await axios.post(`${URL}/confirm`, { sessionId });
    return response.data;
}

export async function getDeposit(id) {
    const response = await axios.get(`${URL}/${id}`);
    return response.data;
}
